import testSimple from 'src/help/markdown/test-simple.md'
import testFull from 'src/help/markdown/test-full.md'
import insightsLinkPropertyRecords from 'src/help/markdown/insights-link-property-records.md'
import insightsLinkDemographics from 'src/help/markdown/insights-link-demographics.md'
import insightsLinkDriveTimeTradeArea from 'src/help/markdown/insights-link-drive-time-trade-area.md'
import insightsLinkTradeArea from 'src/help/markdown/insights-link-trade-area.md'
import insightsLinkRadiusRingsTradeArea from 'src/help/markdown/insights-link-radius-rings-trade-area.md'
import insightsLinkPerformanceBenchmarks from 'src/help/markdown/insights-link-performance-benchmarks.md'
import insightsLinkLocationVisits from 'src/help/markdown/insights-link-location-visits.md'
import insightsLinkAreaVisits from 'src/help/markdown/insights-link-area-visits.md'
import insightsLinkMarketOverlapVoid from 'src/help/markdown/insights-link-market-overlap-void.md'
import insightsLinkVenueDebug from 'src/help/markdown/insights-link-venue-debug.md'
import sidebarAgeDistributionTitle from 'src/help/markdown/sidebar-age-distribution-title.md'
import sidebarAvailableInsightsTitle from 'src/help/markdown/sidebar-available-insights-title.md'
import sidebarBuildingAndLotTitle from 'src/help/markdown/sidebar-building-and-lot-title.md'
import sidebarConsumerSpendTitle from 'src/help/markdown/sidebar-consumer-spend-title.md'
import sidebarEthnicityTitle from 'src/help/markdown/sidebar-ethnicity-title.md'
import sidebarFootfallTitle from 'src/help/markdown/sidebar-footfall-title.md'
import sidebarNearbyVenuesTitle from 'src/help/markdown/sidebar-nearby-venues-title.md'
import sidebarPhotosTitle from 'src/help/markdown/sidebar-photos-title.md'
import sidebarPopulationTitle from 'src/help/markdown/sidebar-population-title.md'
import sidebarVenueDetailsContent from 'src/help/markdown/sidebar-venue-details-content.md'
import lockedFeature from 'src/help/markdown/locked-feature.md'
import mapToolsCustomArea from 'src/help/markdown/map-tools-custom-area.md'
import footTrafficTrendsRange from 'src/help/markdown/foot-traffic-trends-range.md'
import footTrafficTrendsPeriod from 'src/help/markdown/foot-traffic-trends-period.md'
import footTrafficTrendsCard from 'src/help/markdown/foot-traffic-trends-card.md'
import footTrafficHourlyCard from 'src/help/markdown/foot-traffic-hourly-card.md'
import footTrafficDailyCard from 'src/help/markdown/foot-traffic-daily-card.md'
import footTrafficCrossVisitationCard from 'src/help/markdown/foot-traffic-cross-visitation-card.md'
import footTrafficOtherCrossVisitationCard from 'src/help/markdown/foot-traffic-other-cross-visitation-card.md'
import footTrafficDurationCard from 'src/help/markdown/foot-traffic-duration-card.md'
import footTrafficCaptureRateCard from 'src/help/markdown/foot-traffic-capture-rate-card.md'
import footTrafficRetentionCard from 'src/help/markdown/foot-traffic-retention-card.md'
import footTrafficProfileCard from 'src/help/markdown/foot-traffic-profile-card.md'
import performanceBenchmarksSameBrandRankCard from 'src/help/markdown/performance-benchmarks-same-brand-rank-card.md'
import performanceBenchmarksSameCategoryAveragesCard from 'src/help/markdown/performance-benchmarks-same-category-averages-card.md'
import performanceBenchmarksSameCategoryRankCard from 'src/help/markdown/performance-benchmarks-same-category-rank-card.md'
import performanceBenchmarksTrendComparisonCard from 'src/help/markdown/performance-benchmarks-trend-comparison-card.md'
import demographicsMapCard from 'src/help/markdown/demographics-map-card.md'
import demographicsTimeSelector from 'src/help/markdown/demographics-time-selector.md'
import propertyRecordsCard from 'src/help/markdown/property-records-card.md'
import propertyRecordsTabs from 'src/help/markdown/property-records-tabs.md'
import propertyRecordsXTabs from 'src/help/markdown/property-records-x-tabs.md'
import propertyRecordsTabNoInfo from 'src/help/markdown/property-records-tab-no-info.md'
import tradeAreaCard from 'src/help/markdown/trade-area-card.md'
import tradeAreaTabs from 'src/help/markdown/trade-area-tabs.md'
import tradeAreaSegmentOne from 'src/help/markdown/trade-area-segment-one.md'
import tradeAreaSegmentTwo from 'src/help/markdown/trade-area-segment-two.md'
import tradeAreaSegmentThree from 'src/help/markdown/trade-area-segment-three.md'
import tradeAreaBenchmarkingNearestCategory from 'src/help/markdown/trade-area-benchmarking-nearest-category.md'
import tradeAreaBenchmarkingTrendComparisonChart from 'src/help/markdown/trade-area-benchmarking-trend-comparison-chart.md'
import tradeAreaBenchmarkingWithinComparison from 'src/help/markdown/trade-area-benchmarking-within-comparison.md'
import downloadToolTitle from 'src/help/markdown/download-tool-title.md'
import downloadToolFormat from 'src/help/markdown/download-tool-format.md'
import downloadToolCustomize from 'src/help/markdown/download-tool-customize.md'
import tenantFinderTableHeaderCoTenancy from 'src/help/markdown/tenant-finder-table-header-co-tenancy.md'
import tenantFinderTableHeaderNearbyTenancy from 'src/help/markdown/tenant-finder-table-header-nearby-tenancy.md'
import tenantFinderTableHeaderDemographics from 'src/help/markdown/tenant-finder-table-header-demographics.md'
import tenantFinderTableHeaderOverall from 'src/help/markdown/tenant-finder-table-header-overall.md'
import contactInfoUnavailable from 'src/help/markdown/contact-info-unavailable.md'

export const HelpMarkdowns: Record<string, string> = {
  'test-simple': testSimple,
  'test-full': testFull,
  'insights-link-property-records': insightsLinkPropertyRecords,
  'insights-link-demographics': insightsLinkDemographics,
  'insights-link-drive-time-trade-area': insightsLinkDriveTimeTradeArea,
  'insights-link-radius-rings-trade-area': insightsLinkRadiusRingsTradeArea,
  'insights-link-trade-area': insightsLinkTradeArea,
  'insights-link-performance-benchmarks': insightsLinkPerformanceBenchmarks,
  'insights-link-location-visits': insightsLinkLocationVisits,
  'insights-link-area-visits': insightsLinkAreaVisits,
  'insights-link-market-overlap-void': insightsLinkMarketOverlapVoid,
  'insights-link-venue-debug': insightsLinkVenueDebug,
  'sidebar-age-distribution-title': sidebarAgeDistributionTitle,
  'sidebar-available-insights-title': sidebarAvailableInsightsTitle,
  'sidebar-building-and-lot-title': sidebarBuildingAndLotTitle,
  'sidebar-consumer-spend-title': sidebarConsumerSpendTitle,
  'sidebar-ethnicity-title': sidebarEthnicityTitle,
  'sidebar-footfall-title': sidebarFootfallTitle,
  'sidebar-nearby-venues-title': sidebarNearbyVenuesTitle,
  'sidebar-photos-title': sidebarPhotosTitle,
  'sidebar-population-title': sidebarPopulationTitle,
  'sidebar-venue-details-content': sidebarVenueDetailsContent,
  'locked-feature': lockedFeature,
  'map-tools-custom-area': mapToolsCustomArea,
  'foot-traffic-trends-range': footTrafficTrendsRange,
  'foot-traffic-trends-period': footTrafficTrendsPeriod,
  'foot-traffic-trends-card': footTrafficTrendsCard,
  'foot-traffic-hourly-card': footTrafficHourlyCard,
  'foot-traffic-daily-card': footTrafficDailyCard,
  'foot-traffic-cross-visitation-card': footTrafficCrossVisitationCard,
  'foot-traffic-other-cross-visitation-card': footTrafficOtherCrossVisitationCard,
  'foot-traffic-duration-card': footTrafficDurationCard,
  'foot-traffic-capture-rate-card': footTrafficCaptureRateCard,
  'foot-traffic-retention-card': footTrafficRetentionCard,
  'foot-traffic-profile-card': footTrafficProfileCard,
  'performance-benchmarks-same-brand-rank-card': performanceBenchmarksSameBrandRankCard,
  'performance-benchmarks-same-category-averages-card': performanceBenchmarksSameCategoryAveragesCard,
  'performance-benchmarks-same-category-rank-card': performanceBenchmarksSameCategoryRankCard,
  'performance-benchmarks-trend-comparison-card': performanceBenchmarksTrendComparisonCard,
  'demographics-map-card': demographicsMapCard,
  'demographics-time-selector': demographicsTimeSelector,
  'property-records-card': propertyRecordsCard,
  'property-records-tabs': propertyRecordsTabs,
  'property-records-x-tabs': propertyRecordsXTabs,
  'property-records-tab-no-info': propertyRecordsTabNoInfo,
  'trade-area-card': tradeAreaCard,
  'trade-area-tabs': tradeAreaTabs,
  'trade-area-segment-one': tradeAreaSegmentOne,
  'trade-area-segment-two': tradeAreaSegmentTwo,
  'trade-area-segment-three': tradeAreaSegmentThree,
  'trade-area-benchmarking-nearest-category': tradeAreaBenchmarkingNearestCategory,
  'trade-area-benchmarking-trend-comparison-chart': tradeAreaBenchmarkingTrendComparisonChart,
  'trade-area-benchmarking-within-comparison': tradeAreaBenchmarkingWithinComparison,
  'download-tool-title': downloadToolTitle,
  'download-tool-format': downloadToolFormat,
  'download-tool-customize': downloadToolCustomize,
  'tenant-finder-table-header-co-tenancy': tenantFinderTableHeaderCoTenancy,
  'tenant-finder-table-header-nearby-tenancy': tenantFinderTableHeaderNearbyTenancy,
  'tenant-finder-table-header-demographics': tenantFinderTableHeaderDemographics,
  'tenant-finder-table-header-overall': tenantFinderTableHeaderOverall,
  'contact-info-unavailable': contactInfoUnavailable,
}
